import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";

// Pages
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import UpcomingPage from "./pages/UpcomingPage";
import PortfolioPage from "./pages/PortfolioPage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import FAQPage from "./pages/FAQPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

// Admin
import { AdminAuthProvider } from "./admin/context/AdminAuthContext";
import { AdminDataProvider } from "./admin/context/AdminDataContext";
import AdminLayout from "./admin/layout/AdminLayout";
import AdminLoginPage from "./admin/pages/AdminLoginPage";
import DashboardPage from "./admin/pages/DashboardPage";
import ProjectsAdminPage from "./admin/pages/ProjectsPage";
import TestimonialsPage from "./admin/pages/TestimonialsPage";
import EnquiriesPage from "./admin/pages/EnquiriesPage";
import CTAPage from "./admin/pages/CTAPage";
import ContentPage from "./admin/pages/ContentPage";
import FiltersPage from "./admin/pages/FiltersPage";

import "@/App.css";

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Public site layout
function PublicLayout() {
  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/projects/:id" element={<ProjectDetailPage />} />
          <Route path="/upcoming" element={<UpcomingPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <AdminAuthProvider>
      <AdminDataProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-right" richColors />
          <Routes>
            {/* Admin Routes - completely separate from public site */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<DashboardPage />} />
              <Route path="dashboard" element={<DashboardPage />} />
              <Route path="projects" element={<ProjectsAdminPage />} />
              <Route path="testimonials" element={<TestimonialsPage />} />
              <Route path="enquiries" element={<EnquiriesPage />} />
              <Route path="cta" element={<CTAPage />} />
              <Route path="content" element={<ContentPage />} />
              <Route path="filters" element={<FiltersPage />} />
            </Route>

            {/* Public Site Routes - with Navbar & Footer */}
            <Route
              path="/*"
              element={
                <div className="App min-h-screen bg-white font-manrope">
                  <PublicLayout />
                </div>
              }
            />
          </Routes>
        </BrowserRouter>
      </AdminDataProvider>
    </AdminAuthProvider>
  );
}

export default App;
